import styled, { CSSObject } from "@emotion/styled";
import React from "react";

import { CoreLink } from "@brexhq/next/src/components/shared/Link/CoreLink";
import type { InlineLinkProps } from "@brexhq/next/src/components/shared/Link/types";
import type { DefaultTheme } from "@brexhq/shared/styles/theming";

const getFooterStyles = (theme: DefaultTheme): CSSObject => ({
  fontFamily: theme.rebirth.fonts.family,
  fontSize: "16px",
  lineHeight: "24px",
  color: theme.colors.content.inverse.tertiary,
  textDecoration: "none",
  "&:hover": {
    color: theme.colors.accent.primary.background.hover,
    textDecoration: "none",
  },
  "&:active": {
    color: theme.colors.accent.primary.background.pressed,
  },
  [theme.breakpoints.MED]: {
    fontSize: "14px",
    lineHeight: "22px",
  },
  [theme.breakpoints.SML]: {
    fontSize: "12px",
    lineHeight: "20px",
  },
});

const StyledRebirthFooterLink = styled(CoreLink)(({ theme }) => {
  return getFooterStyles(theme);
});

export const CookieLawButton = styled("button")(({ theme }) => {
  return {
    background: "none",
    border: "none",
    padding: "0",
    ...getFooterStyles(theme),
  };
});

export const RebirthFooterLink = React.forwardRef<
  HTMLAnchorElement,
  InlineLinkProps
>(function RebirthFooterLink(
  { to, label, target, rel, prefetch, ...defaultProps },
  ref,
) {
  return (
    <StyledRebirthFooterLink
      ref={ref}
      to={to}
      target={target}
      rel={rel}
      prefetch={prefetch}
      {...defaultProps}
    >
      {label}
    </StyledRebirthFooterLink>
  );
});
